import { Show } from "solid-js";
import TranscriptPanel from "../TranscriptPanel";
import TranslationPanel from "../TranslationPanel";
import CaseworkerInterpreterPanels from "../CaseworkerInterpreterPanels";
import type { MeetingInsights } from "../../types/insights";

export default function TranscriptTab(props: {
  interpreterMode: boolean;
  utterances: any[];
  insights?: MeetingInsights | null;
  targetLang: string;
  sourceLang: string;
}) {
  return (
    <>
      <Show when={!props.interpreterMode}>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TranscriptPanel utterances={props.utterances} insights={props.insights} />
          <Show when={props.targetLang}>
            <TranslationPanel
              utterances={props.utterances}
              langLabel={
                new Intl.DisplayNames("en", { type: "language" }).of(props.targetLang) ||
                props.targetLang
              }
            />
          </Show>
        </div>
      </Show>
      <Show when={props.interpreterMode}>
        <CaseworkerInterpreterPanels
          utterances={props.utterances}
          speaker1Lang={props.sourceLang || "en-US"}
          speaker2Lang={props.targetLang || ""}
        />
      </Show>
    </>
  );
}

